// extracted by mini-css-extract-plugin
export var galleryMasonryImageWrapper = "r_jN d_jN d_cr";
export var galleryMasonryImage = "r_jM d_jM d_s d_bN d_dx";
export var alignLeft = "r_qK d_fl d_bC d_dr";
export var alignCenter = "r_bL d_fm d_bz d_ds";
export var alignRight = "r_qL d_fn d_bD d_dt";
export var galleryContainer = "r_qM d_dS";
export var galleryContainerFull = "r_qN d_dQ";
export var galleryRowWrapper = "r_qP d_b8";
export var galleryGuttersImage = "r_jQ d_jQ d_G d_cr";
export var galleryNoGuttersImage = "r_jP d_jP d_G d_cz";
export var galleryTextGutters = "r_jK d_jK d_cs";
export var galleryTextNoGutters = "r_jL d_jL d_cs";
export var galleryTextMasonry = "r_qQ d_jK d_cs";
export var galleryImageWrapper = "r_qR d_fc d_W";
export var descText = "r_qS d_jR d_X d_6 d_4 d_5 d_k";
export var guttersDesc = "r_qT";